import { ClientContact, CreateClientContact, UpdateClientContact } from '@/entities/clientContact';
import { Client, CreateClient, UpdateClient, UpdateClientStatusDto } from '@/entities/clients';
import { ClientService } from '@/services/ClientsService';
import { Contact } from 'lucide-react';
import { useEffect, useState } from 'react';

export function useClients(){
  
  const [contatos, setContatos] = useState<ClientContact[] | []>([]);
  const [clientsUse, setClients] = useState<Client[]>([]);
  const [foundedClients, setFoundedClients] = useState<Client[]>([]);
  const [errorGetClients, setErrorGetClients] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [contacts, setContacts] = useState<ClientContact[]>([]);
  const [ alterStatus2, setAlterStatus2 ] = useState(false);
  const [ client, setClient ] = useState<any>();

  useEffect(() =>{
    fetchClientList();
  },[]);

  const fetchClientList = async () => {
    try{
      const response = await ClientService.getClientsByCompanyId();
      if(response){  
        setClients(response);
      }
    }catch(error){
      console.error(`Falha ao carregar os dados: ${error}`);
      setErrorGetClients(true);
    }
  };

  const searchClients = async (contains:string) => {
    try {
      const response = await ClientService.searchClient(contains);
      if(response){
        setFoundedClients(response);
      }
    } catch (error) {
      console.error(`Falha ao carregar os dados: ${error}`);
    }
  };

  const getContactList = async (clientId: number):Promise<ClientContact[] | []> => {
    try{
      const response = await ClientService.getContact(clientId);     
      if(response){
        return response;
      }
      return [];
    }catch(error){
      console.error(`Falha ao carregar os dados: ${error}`);
      return [];
    }
  };

  const createClient = async (client: CreateClient) =>{
    const response = await ClientService.createClient(client);
    if(response){
      fetchClientList();
      return response;
    }
  };

  const create = async (client: CreateClient) => {
    const response = await ClientService.create(client);
    if(response){  
      fetchClientList();
      return response;
    }
  }

  const deleteCascadeCliente = async (id: number, adId:number) => {
    try{
      await ClientService.deleteCascadeClient(id, adId);
    }catch(e){
      console.error('Deu ruim, meu chapa: ',e);
    }
  };

  const updateCliente = async (client:UpdateClient)=> {
    try{
      const response = await ClientService.updateClient(client);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim, meu chapa: ',e);
    }
  };

  const createContact = async (clientId: number, contact: CreateClientContact) => {
    try{
      const response = await ClientService.createClientContact(clientId, contact);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim, meu chapa: ',e);
    }
  };

  const updateContact = async (contact: UpdateClientContact) => {
    try{
      const response = await ClientService.updateClientContact(contact);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim, meu chapa: ',e);
    }
  };

  const deleteContact = async (id:number) => {
    try{
      const response = await ClientService.deleteClientContact(id);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim, meu chapa: ',e);
    }
  };

  const deleteAllContact = async (clientId:number) => {
    try{
      const response = await ClientService.deleteAllContact(clientId);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim, meu chapa: ',e);
    }
  };

  const updateClientStatus= async (id:number, client:UpdateClientStatusDto) => {
    try{
      const response = await ClientService.updateClientStatus(id, client);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim, meu chapa: ',e);
    }
  };

  return {
    clientsUse,
    deleteOpen,
    contacts,
    alterStatus2,
    contatos,
    client,
    foundedClients,
    searchClients, 
    setClient, 
    setContatos,
    updateClientStatus,
    createClient,
    setDeleteOpen,
    deleteCascadeCliente,
    updateCliente,
    getContactList,
    createContact,
    updateContact,
    deleteContact,
    deleteAllContact,
    setAlterStatus2,
    create,
    fetchClientList
  };
            
}
